<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <!-- <v-flex xs12 sm12 md12 lg8>
                <v-flex xs12 sm12 md12>
                    <cpnLeadSelection/>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-layout row justify-space-between wrap>
                        <v-flex xs12 sm12 md6 padding>
                            <cpnLeadDetail/>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <cpnLeadEconomy/>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-flex> -->
      <v-flex xs12 sm12 md12 lg12>
        <cpnSalesDay />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// import LeadSelection from '../components/sales/LeadSelection'
// import LeadDetail from '../components/sales/LeadDetail.vue'
// import LeadEconomy from '../components/sales/LeadEconomy.vue'
import SalesDay from "../components/sales/SalesDay";

export default {
  components: {
    // cpnLeadSelection: LeadSelection,
    // cpnLeadDetail: LeadDetail,
    // cpnLeadEconomy: LeadEconomy,
    cpnSalesDay: SalesDay,
  },
  data: function () {
    return {
      loading: false,
    };
  },
};
</script>
